import React from "react";
import classNames from "classnames";
import styles from "../styles/navigation-tabs.module.scss";
import {observer} from "mobx-react";
import {KeyboardArrowLeft} from "../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../../core/icons/keyboard-arrow/keyboard-arrow-right";
import {NAVIGATION_TABS} from "../navigation-tabs-module.consts";

export const NavigationTabsModuleArrowForward = observer(({controller, onClick, isScrollable, shouldRenderArrow}) => {
  const {device: {isRtl}} = controller;

  const containerProps = {
    className: classNames(styles.arrow_container, {[styles.disable_arrow]: !shouldRenderArrow}),
  }

  const nextProps = {
    className: classNames(styles.arrow),
    onClick: () => onClick(NAVIGATION_TABS.DIRECTIONS.next)
  }

  return (
    isScrollable ? <div {...containerProps}>
      {
        shouldRenderArrow ? isRtl ? <KeyboardArrowLeft {...nextProps}/> : <KeyboardArrowRight {...nextProps}/> : null
      }
    </div> : null
  )
});
